import gsap from 'gsap';
import gsapCore from 'gsap/gsap-core';
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  init() {

    if($('.block-perks').length){
      gsap.registerPlugin(ScrollTrigger); 
      var blockName = '.block-perks';
      gsap.set(blockName, {autoAlpha:0, y:100});

      gsap.to(blockName, {
        scrollTrigger : {
          trigger : blockName,
          start : 'top center',
          end : 'bottom bottom'
        },
        autoAlpha:1, y:0
      });

      $('.nav-tabs a').on('click', function(e){
        e.preventDefault();
        var target = $(this).attr('href');
        $('.nav-tabs a').removeClass('active');
        $(this).addClass('active');
        $('.tab-pane').removeClass('active');
        $(target).addClass('active');
      })
    }
  },
  finalize() {}
}